import {configureStore} from '@reduxjs/toolkit'

// Dummy reducer to satisfy Redux requirement
const dummyReducer = (state = {}) => state;

const store = configureStore({
  reducer: {
    dummy: dummyReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export default store
